const isPdfUrl = (url) => {
    if (typeof url !== 'string' || url.startsWith('data:')) return false
    return /\.pdf(\?|#|$)/i.test(url)
}

export default isPdfUrl
